var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /** @format */

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Translate } from "../../I18N";
import { Icon } from "../../UI";
import { bindActionCreators } from 'redux';
import { closeImportProgress } from "../actions/uploadsActions";
import Immutable from 'immutable';
import StackTrace from "../../components/Elements/StackTrace";

export class ImportProgress extends Component {
  render() {
    const {
      close,
      importState: { importStart, importProgress, importError, importEnd }
    } = this.props;
    if (!importStart && !importProgress) {
      return false;
    }
    if (importEnd) {
      return /*#__PURE__*/(
        _jsx("div", { className: "alert alert-info" }, void 0, /*#__PURE__*/
        _jsx(Icon, { icon: "check", size: "2x" }), /*#__PURE__*/
        _jsx("div", { className: "force-ltr" }, void 0, /*#__PURE__*/
        _jsx(Translate, { translationKey: "Import completed" }, void 0, "Import completed. Number of entities created:"

        ), "\xA0",

        importProgress, /*#__PURE__*/
        _jsx("br", {}), /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Indexing entities may take a few minutes")
        ), /*#__PURE__*/
        _jsx(Icon, { style: { cursor: 'pointer' }, icon: "times", onClick: close })
        ));

    }

    if (importError.get('prettyMessage')) {
      return /*#__PURE__*/(
        _jsx("div", {}, void 0, /*#__PURE__*/
        _jsx("div", { className: "alert alert-danger" }, void 0, /*#__PURE__*/
        _jsx(Icon, { icon: "exclamation-triangle", size: "2x" }), /*#__PURE__*/
        _jsx("div", { className: "force-ltr" }, void 0, /*#__PURE__*/
        _jsx(Translate, {}, void 0, "The import process threw an error:")
        ), /*#__PURE__*/
        _jsx(Icon, { style: { cursor: 'pointer' }, icon: "times", onClick: close })
        ), /*#__PURE__*/
        _jsx(StackTrace, {
          message: importError.get('prettyMessage'),
          validations: importError.get('validations') }
        )
        ));

    }

    return /*#__PURE__*/(
      _jsx("div", { className: "alert alert-info" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "cog", size: "2x" }), /*#__PURE__*/
      _jsx("div", { className: "force-ltr" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Importing data in progress"), ": ", importProgress
      )
      ));

  }
}











export const mapStateToProps = (state) => ({
  importState: state.importEntities
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ close: closeImportProgress }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportProgress);